<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" class="inline-form">
        <el-form-item label="交易时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
        <el-form-item label="订单流水号">
          <el-input v-model="searchInfo.orderId" clearable></el-input>
        </el-form-item>
        <el-form-item label="收款编号">
          <el-input v-model="searchInfo.merchantId" clearable></el-input>
        </el-form-item>
        <el-form-item label="交易类型">
          <el-select v-model="searchInfo.payTypes" multiple collapse-tags placeholder="请选择">
            <el-option
            v-for="item in payTypesOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="直属代理商">
          <el-input v-model="searchInfo.agentId" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="交易状态" v-if="!isInstitution">
            <el-select v-model="searchInfo.payStatus" placeholder="请选择">
                <el-option
                v-for="item in payStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select> -
            <el-select v-model="searchInfo.paySecondStatus" placeholder="请选择">
                <el-option
                v-for="item in paySecondStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="searchInfo.sourceType" placeholder="请选择">
            <el-option
            v-for="item in sourceTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="searchInfo.orderNum" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单金额(元)">
            <el-input style="width:100px;" v-model="searchInfo.minAmount" auto-complete="off"></el-input> -
            <el-input style="width:100px;" v-model="searchInfo.maxAmount" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="门店编号">
          <el-input v-model="searchInfo.shopId" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchLoading"></auth-button>
          <auth-button icon="el-icon-download" opt="export" plain :loading="exportButtonLoading" @click.native="buttomExport" label="导出"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 提取记录table -->
      <el-table
        stripe
        border
        style="width:100%;"
        v-loading="searchLoading"
        :data="packagelist"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
              label="序号"
              type="index"
              width="100"
              align="center">
            <template slot-scope="scope">
              <span>{{scope.$index +(paginations.pageNo - 1) * paginations.pageSize + 1}}</span>
            </template>
        </el-table-column>
        <el-table-column v-for="item in labelHeader" :key="item.key" :property="item.key" :label="item.label" align="center">
            <template slot-scope="scope">
                {{scope.row[scope.column.property]}}
            </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo" :size="paginations.pageSize"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import { queryTradeFlowData, exportTradeFlowData } from '@/api/transaction'
import { parseTime } from '@/utils/formatTime'
export default {
  name: 'CaterDishOrderInfo',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 7 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      searchLoading: false,
      creatTime: [todayZeroStr, todayStr],
      packagelist: '',
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        payStatus: '',
        paySecondStatus: '',
        payTypes: '',
        sourceType: '',
        orderNum: '',
        minAmount: '',
        maxAmount: '',
        orderId: '',
        merchantId: '',
        shopId: ''
        // agentId: ''
      },
      exportForm: {
        moduleCode: 8,
        moduleName: '分润提取',
        menuName: '分润提取记录'
      },
      payTypesOptions: [{
        value: 0,
        label: '微信'
      }, {
        value: 1,
        label: '支付宝'
      }, {
        value: 2,
        label: '银联二维码'
      }],
      payStatusOptions: [{
        value: 1,
        label: '交易（支付）'
      }, {
        value: 2,
        label: '退款'
      }],
      paySecondStatusOptions: [{
        value: 1,
        label: '支付中/退款中'
      }, {
        value: 5,
        label: '支付成功/退款成功'
      }, {
        value: 7,
        label: '支付失败/退款失败'
      }, {
        value: 11,
        label: '取消订单成功'
      }],
      sourceTypeOptions: [{
        value: 0,
        label: '扫码点餐订单'
      }, {
        value: -1,
        label: '掌柜收款'
      }],
      labelHeader: [{
        label: '交易时间',
        key: 'tradeDoneTime'
      }, {
        label: '订单流水号',
        key: 'orderId'
      }, {
        label: '门店编号',
        key: 'shopId'
      }, {
        label: '收款编号',
        key: 'merchantId'
      }, {
        label: '商家简称',
        key: 'shopName'
      }, {
        label: '直属代理商',
        key: 'agentId'
      }, {
        label: '商户交易单号',
        key: 'orderNum'
      }, {
        label: '订单类型',
        key: 'sourceType'
      }, {
        label: '交易类型',
        key: 'payType'
      }, {
        label: '交易状态',
        key: 'finalPayStatusToFront'
      }, {
        label: '订单金额',
        key: 'amount'
      }]
    }
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getPackageList()
    },
    dateChange (value) {
      this.creatTime = value
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.paginations.count = 0
      this.getPackageList()
    },
    /**
       * 删除提交参数中的空字段
       */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    formatPayType (e) {
      switch (e) {
        case 0:
          return '微信'
        case 1:
          return '支付宝'
        case 2:
          return '银联二维码'
        default:
          break
      }
    },
    formatSourceType (e) {
      switch (e) {
        case 0:
          return '扫码点餐订单'
        case -1:
          return '掌柜收款'
        default:
          break
      }
    },
    getPackageList () {
      this.searchLoading = true
      var tempInfo = JSON.parse(JSON.stringify(this.searchInfo)) // 深拷贝
      tempInfo.payTypes = this.searchInfo.payTypes.join(',')
      tempInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      tempInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      // const param = {
      //   pageNo: this.paginations.pageNo,
      //   pageSize: this.paginations.pageSize
      // }
      this.formatParams(tempInfo)
      const params = qs.stringify(Object.assign(tempInfo, this.paginations))
      queryTradeFlowData(params).then(data => {
        this.searchLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.packagelist = data.list
          this.paginations.count = data.totalCount
          this.packagelist.forEach(item => {
            item.payType = this.formatPayType(item.payType)
            item.sourceType = this.formatSourceType(item.sourceType)
            item.amount = (item.amount / 100).toFixed(2)
          })
        }
      })
    },
    buttomExport () {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      // var startDate = this.searchInfo.startDate
      // var endDate = this.searchInfo.endDate
      // if (startDate == null || startDate === '') {
      //   this.$message({
      //     showClose: true,
      //     message: '起始时间不能为空，请检查后重试',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (endDate == null || endDate === '') {
      //   this.$message({
      //     showClose: true,
      //     message: '结束时间不能为空，请检查后重试',
      //     type: 'error'
      //   })
      //   return
      // }
      // if (startDate.substring(0, 8) !== endDate.substring(0, 8)) {
      //   this.$message({
      //     showClose: true,
      //     message: '目前不支持跨月导出，请检查后重试',
      //     type: 'error'
      //   })
      //   return
      // }
      // 当点击查询时，显示第一页
      this.paginations.pageNo = 1
      this.exportList()
    },
    exportList () {
      var tempInfo = JSON.parse(JSON.stringify(this.searchInfo)) // 深拷贝
      tempInfo.payTypes = this.searchInfo.payTypes.join(',')
      const data = qs.stringify(Object.assign({}, tempInfo, this.paginations, {
        moduleCode: 1,
        moduleName: '交易',
        menuName: '扫码点单交易查询'
      }))
      exportTradeFlowData(data).then(response => {
        // localStorage.setItem('EXPORT_TRADE_TIME_' + this.agentId, Date.now())
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: '导出失败，系统错误',
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    // this.getPackageList()
  }
}
</script>

<style lang="scss" scoped>
  @mixin flex-horizontal {
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.extract-amount {
  @include flex-horizontal;
  justify-content: center;
  margin: 30px 0;
  .extract-amount-input {
    margin-left: 15px;
    width: 300px;
    .extract-all {
      cursor: pointer;
    }
  }
}
</style>
